import { onBeforeUnmount } from 'vue'

const TICK_INTERVAL = 1000
const subscribers = new Set()
let timerId = null

const notifySubscribers = () => {
  subscribers.forEach((callback) => {
    try {
      callback()
    } catch (error) {
      console.error('[useGlobalTimer] subscriber error', error)
    }
  })
}

const startGlobalTimer = () => {
  if (timerId !== null) {
    return
  }
  timerId = setInterval(notifySubscribers, TICK_INTERVAL)
}

const stopGlobalTimer = () => {
  if (timerId === null) {
    return
  }
  clearInterval(timerId)
  timerId = null
}

/**
 * 订阅全局每秒计时器
 * @param {Function} callback 每秒触发的回调
 * @returns {Function} 取消订阅
 */
export const subscribeGlobalTimer = (callback) => {
  if (typeof callback !== 'function') {
    return () => {}
  }
  subscribers.add(callback)
  if (subscribers.size === 1) {
    startGlobalTimer()
  }
  return () => {
    subscribers.delete(callback)
    if (subscribers.size === 0) {
      stopGlobalTimer()
    }
  }
}

/**
 * 全局每秒计时器（单例），组件内使用会在卸载时自动取消订阅
 * @param {Function} callback 每秒触发的回调
 * @param {{ immediate?: boolean }} options immediate 是否立即执行一次，默认 true
 * @returns {{ unsubscribe: Function }}
 */
export const useGlobalTimer = (callback, options = {}) => {
  const { immediate = true } = options

  if (immediate && typeof callback === 'function') {
    callback()
  }

  const unsubscribe = subscribeGlobalTimer(callback)
  onBeforeUnmount(unsubscribe)

  return { unsubscribe }
}

export default useGlobalTimer
